module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/en_3-715def7c355a01a5c61383826d2527da.jpg";